// extracted by mini-css-extract-plugin
export default {"content":"AddAccountingEntity_content__bHUpe","title":"AddAccountingEntity_title__pbBTB"};